import React, { useState } from "react";
import { connect } from "react-redux";
import { fetch } from "../../actions";
import { Divider, Tabs, Tag, Tooltip } from "antd";
import TabelaPadrao from "../../components/TabelaPadrao";
import { LabelPadrao, ObsIcon, TagIcon, TagMotivoCancelamento, TextAreaPadrao } from "../../components/Base";
import formatarData from "../../Utils/formatarData";
import toLocale from "../../Utils/ToLocaleString";
import culture from "../../Utils/Culture";
import VendaDetalhesOutros from "./VendaDetalhesOutros";
import VendaDetalheModal from "./VendaDetalheModal";
import PreVendaDetalheModal from "./PreVendaDetalheModal";
import NotaFiscalDetalhePadrao from "./NotaFiscal/NotaFiscalDetalhePadrao";

const { TabPane } = Tabs;

function VendaDetalhesPadrao({ venda, title, modelo, isLocal, ...props }) {
  const [vendaDetalheId, setVendaDetalheId] = useState(null);
  const [preVendaDetalheId, setPreVendaDetalheId] = useState(null);

  return <>
    {venda && <Tabs defaultActiveKey="1" style={{ minHeight: 450 }}>
      <TabPane tab={title} key="1">
        <div>
          <div style={{ display: "flex" }}>
            <p><b>Número: </b>{venda.numero}</p>
            <p style={{ margin: "0 10px" }}><b>Data: </b>{formatarData(venda.data).DATAHORA}</p>
            <p><b>Empresa: </b>{venda.det.empresa}</p>
          </div>
          <div style={{ display: "flex" }}>
            {!!venda.det.cliente && <p style={{ marginRight: 10 }}><b>Cliente: </b>{venda.det.cliente.label}</p>}
            {!!venda.det.vendedor && <p><b>Vendedor: </b>{venda.det.vendedor}</p>}
          </div>

          {!!venda.produtos.length && <>
            <Divider orientation="left">Produtos</Divider>
            <TabelaPadrao columns={columns} data={venda.produtos} style={{ marginTop: 10 }} />
          </>}

          {!!venda.servicos.length && <>
            <Divider orientation="left">Serviços</Divider>
            <TabelaPadrao columns={columnsDetServ} data={venda.servicos} style={{ marginTop: 10 }} />
          </>}

          <Divider orientation="left">Pagamentos</Divider>
          {venda.pagamentos && <TabelaPadrao columns={columnsDetPgto} data={venda.pagamentos} />}
          {venda.observacoes && <>
            <LabelPadrao>Observações</LabelPadrao>
            <TextAreaPadrao disabled value={venda.observacoes} />
          </>}

          <div style={{ marginTop: 25 }}>
            {!venda.dataCan && <div style={{ display: "flex" }}>
              {props.children}
            </div>}
          </div>
        </div>
      </TabPane>

      {!!venda.nf && <TabPane tab="Nota fiscal" key="2">
        <NotaFiscalDetalhePadrao dados={venda.nf} />
      </TabPane>}

      <TabPane tab="Outros" key="outros">
        <VendaDetalhesOutros isLocal={isLocal} vendaId={venda.id} setVendaId={setVendaDetalheId} setPreVendaId={setPreVendaDetalheId} />
      </TabPane>

    </Tabs>}

    <VendaDetalheModal idVenda={vendaDetalheId} isLocal={isLocal} onCancel={() => setVendaDetalheId(null)} />
    <PreVendaDetalheModal id={preVendaDetalheId} onCancel={() => setPreVendaDetalheId(null)} />

    {venda.dataCan && !props.showPrintBtn && <TagMotivoCancelamento data={venda.dataCan} motivo={venda.motivoCan} color="red" style={{ width: "100%", padding: 10, textAlign: "center", borderRadius: 15, marginTop: 25 }} />}
  </>;
}

export default connect(null, { fetch })(VendaDetalhesPadrao);

const columns = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: "Totais",
  },
  {
    Header: "Descrição",
    accessor: "produto",
    Cell: props => <div>
      <span>{props.row.original.produto}</span>
      {!!props.row.original?.obs && <Tooltip placement="bottom" title={props.row.original.obs}>
        <ObsIcon style={{ fontSize: 15, marginLeft: 5 }} />
      </Tooltip>}
    </div>,
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    Cell: props => <div>
      <span>{culture.format(props.row.original?.qtdPaga || props.row.original?.qtd)}</span>
      {!!props.row.original?.qtdExtra && <Tooltip placement="left" title="Quantidade extra">
        <span style={{ paddingLeft: 5, fontSize: "0.9em" }}>({culture.format(props.row.original?.qtdExtra)})</span>
      </Tooltip>}
    </div>,
    tipo: "right",
    SomarQtd: true
  },
  {
    Header: "Valor unitário",
    accessor: "valorUnitario",
    tipo: "rs",
    Somar: true
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    Cell: props => <div>
      <Tooltip placement="left" title={props.row.original?.promocao}>
        <TagIcon style={{ fontSize: 15, marginRight: 5, visibility: !!props.row.original?.promocao ? "visible" : "hidden" }} className="row-verde" />
      </Tooltip>
      <span>{toLocale(props.row.original?.desconto)}</span>
    </div>,
    tipo: "right",
    Somar: true
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Frete",
    accessor: "valorFrete",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Valor total",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true
  },
];

const columnsDetServ = [
  {
    Header: "Código",
    accessor: "codigo",
    Footer: " ",
  },
  {
    Header: "Descrição",
    accessor: "servico",
    Cell: props => <div>
      <span>{props.row.original.servico}</span>
      {!!props.row.original?.obs && <Tooltip placement="bottom" title={props.row.original.obs}>
        <ObsIcon style={{ fontSize: 15, marginLeft: 5 }} />
      </Tooltip>}
    </div>,
  },
  {
    Header: "Prestador de serviço",
    accessor: "prestador",
  },
  {
    Header: "Quantidade",
    accessor: "qtd",
    tipo: "dec",
    SomarQtd: true,
  },
  {
    Header: "Valor Un.",
    accessor: "valorUnitario",
    tipo: "rs",
  },
  {
    Header: "Desconto",
    accessor: "desconto",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Acréscimo",
    accessor: "acrescimo",
    tipo: "rs",
    Somar: true,
  },
  {
    Header: "Total Líquido",
    accessor: "valorTotal",
    tipo: "rs",
    Somar: true,
  },
];

const columnsDetPgto = [
  {
    Header: "Modalidade",
    accessor: "nome",
    Cell: props => <span >{props.row.original.nome}{!!props.row.original?.bandeiraNome ? ` - ${props.row.original?.bandeiraNome}` : ""}</span>,
    Footer: " ",
  },
  {
    Header: "Troco",
    accessor: "troco",
    Cell: props => (props.row.original.tipo == "troco" && props.row.original.troco != 0) ? <span >{props.row.original.troco && toLocale(props.row.original.troco)} <span style={{ opacity: 0.5, marginLeft: 10 }}>({toLocale(props.row.original.recebido)})</span></span> : <></>,
  },
  {
    Header: "Valor total",
    accessor: "valor",
    tipo: "rs",
    Somar: true,
  },
];
